import { MessagesLandingMenuItem } from './types'
import { MenuItem } from './MenuItem'

interface MenuItemsRendererProps {
  menuItems: MessagesLandingMenuItem[]
  expandedItems: string[]
  toggleItem: (id: string) => void
  moveItemUp: (id: string) => void
  moveItemDown: (id: string) => void
  addChildItem: (id: string, newItem: MessagesLandingMenuItem) => void
  deleteItem: (id: string) => void
  editItem: (id: string, updatedItem: Partial<MessagesLandingMenuItem>) => void
}

export function MenuItemsRenderer({
  menuItems,
  expandedItems,
  toggleItem,
  moveItemUp,
  moveItemDown,
  addChildItem,
  deleteItem,
  editItem,
}: MenuItemsRendererProps) {
  // Render a menu item and its children
  const renderMenuItem = (item: MessagesLandingMenuItem, index: number, depth = 0, parentId = '') => {
    const id = parentId ? `${parentId}-${index}` : `${index}`
    const isExpanded = expandedItems.includes(id)
    const hasChildren = item.items && item.items.length > 0

    // Only top-level items should have an icon
    const showIcon = depth === 0

    const rows: JSX.Element[] = []

    // Add the current item
    rows.push(
      <MenuItem
        key={id}
        item={item}
        id={id}
        depth={depth}
        isExpanded={isExpanded}
        hasChildren={hasChildren}
        showIcon={showIcon}
        toggleItem={toggleItem}
        moveItemUp={moveItemUp}
        moveItemDown={moveItemDown}
        addChildItem={addChildItem}
        deleteItem={deleteItem}
        editItem={editItem}
      />
    )

    // Add children if expanded
    if (isExpanded && hasChildren) {
      item.items.forEach((child, childIndex) => {
        const childRows = renderMenuItem(child, childIndex, depth + 1, id)
        rows.push(...childRows)
      })
    }

    return rows
  }

  // Render all rows
  const renderAllRows = () => {
    const rows: JSX.Element[] = []

    menuItems.forEach((item, index) => {
      const itemRows = renderMenuItem(item, index)
      rows.push(...itemRows)
    })

    return rows
  }

  return <>{renderAllRows()}</>
}
